var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 98.34 98.34",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80.145,38.58c0-15.485-17.977-28.083-40.072-28.083C17.976,10.497,0,23.095,0,38.58c0,8.789,5.646,16.851,15.52,22.209 c-1.65,6.028-4.281,13.786-7.717,17.933C7.573,79,7.532,79.389,7.701,79.709c0.155,0.294,0.46,0.478,0.79,0.478 c0.027,0,0.055-0.002,0.082-0.004c0.75-0.068,18.359-1.805,29.629-13.552c0.62,0.019,1.243,0.031,1.87,0.031 C62.168,66.662,80.145,54.065,80.145,38.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.34,46.237c0-10.3-7.955-19.314-19.781-24.202c4.424,5.02,7.002,10.981,7.002,17.378 c0,17.781-19.846,32.25-44.239,32.25c-0.014,0-0.03,0-0.044,0c5.162,1.699,10.919,2.656,16.99,2.656 c0.627,0,1.25-0.012,1.87-0.032c11.271,11.75,28.88,13.483,29.63,13.552c0.026,0.003,0.053,0.004,0.082,0.004 c0.329,0,0.635-0.182,0.789-0.476c0.17-0.321,0.129-0.71-0.102-0.986c-3.436-4.147-6.066-11.903-7.717-17.935 C92.693,63.09,98.34,55.026,98.34,46.237z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFilled);
export default __webpack_public_path__ + "static/media/chat_filled.200c05bb4c58ca6ca6ebe897a4e989e1.svg";
export { ForwardRef as ReactComponent };